module.exports = __webpack_public_path__ + "static/media/background_4_2.aa83b205.png";